import { useCallback } from 'react';

import { useToasts } from 'dibs-toaster/exports/useToasts.ts';

import {
    AddToFavoritesToastContent,
    RemoveFromFavoritesToastContent,
} from './FavoritesToastsContent.tsx';
import { SHARED_TOAST_PROPS } from './sharedToastProps.ts';
import { isItemFavoritingFeb2026Variant, isItemFavoritingVariant } from './abTests.ts';
import { trackItemFavoritingToast } from './tracking.ts';
import { ADD_TO_FAVORITES_ACTION } from './constants.ts';

const useFavoritesToasts = (): {
    addToFavoritesToast: () => void;
    removeFromFavoritesToast: () => void;
} => {
    const { addToast } = useToasts();

    const addToFavoritesToast = useCallback(() => {
        const isItemFavoritingNov25Variant = isItemFavoritingVariant();
        const isItemFavoritingFeb26Variant = isItemFavoritingFeb2026Variant();

        // Show toast for Nov2025 test OR desktop test (desktop only)
        const shouldShowToast = isItemFavoritingNov25Variant || isItemFavoritingFeb26Variant;

        if (!shouldShowToast) {
            return;
        }

        addToast({
            toast: {
                ...SHARED_TOAST_PROPS,
                children: <AddToFavoritesToastContent />,
            },
            toastAction: ADD_TO_FAVORITES_ACTION,
        });
        trackItemFavoritingToast({ trigger: 'favorited' });
    }, [addToast]);

    const removeFromFavoritesToast = useCallback(() => {
        const isItemFavoritingNov25Variant = isItemFavoritingVariant();
        const isItemFavoritingFeb26Variant = isItemFavoritingFeb2026Variant();

        // Show toast for Nov2025 test OR desktop test (desktop only)
        const shouldShowToast = isItemFavoritingNov25Variant || isItemFavoritingFeb26Variant;

        if (!shouldShowToast) {
            return;
        }

        addToast({
            toast: {
                ...SHARED_TOAST_PROPS,
                children: <RemoveFromFavoritesToastContent />,
            },
        });
        trackItemFavoritingToast({ trigger: 'favorite removed' });
    }, [addToast]);

    return {
        addToFavoritesToast,
        removeFromFavoritesToast,
    };
};

export { useFavoritesToasts };
